import {
  Divider,
  Flex,
  Image,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTheme } from "@emotion/react";
import { useEffect, useRef, useState } from "react";
import Layout from "../../containers/Layout";
import "./Header.css";

const Header = ({ materialesTotales }) => {
  const { colors } = useTheme();
  const [width, setWidth] = useState(0);
  const targetRef = useRef();
  const { colorMode } = useColorMode();
  const [lessons, setLessons] = useState(8003); // Starting with 8k lessons

  // Function to generate a random integer between min and max (inclusive)
  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  useEffect(() => {
    if (targetRef.current) {
      setWidth(targetRef.current.offsetWidth);
    }
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Load the initial lessons count from localStorage or start with 7400
    const storedLessons = localStorage.getItem("lessonsCount");
    if (storedLessons) {
      setLessons(parseInt(storedLessons, 10));
    }

    // Increment the lessons count by a random number between 1 and 2 every day
    const today = new Date().toDateString();
    const lastUpdated = localStorage.getItem("lastUpdated");
    if (lastUpdated !== today) {
      const increment = getRandomInt(1, 2); // Get a random increment value
      const updatedLessons = parseInt(storedLessons || lessons, 10) + increment;
      setLessons(updatedLessons);
      localStorage.setItem("lessonsCount", updatedLessons.toString());
      localStorage.setItem("lastUpdated", today);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, [lessons]);

  const bannerImageUrl =
    colorMode === "light"
      ? "./images/banner_img2Gris.png"
      : "./images/banner_img2.png";

  return (
    <Layout mt={16}>
      <Flex justifyContent={"center"} ref={targetRef}>
        {width >= 768 ? (
          <Image
            src={bannerImageUrl}
            alt="Banner Image Desktop"
            width="800px"
            height="400px" // Tamaño fijo para evitar CLS
            objectFit="contain"
            className="fade-in"
            loading="lazy"
          />
        ) : (
          <Image
            src="./images/banner_img3.png"
            alt="Banner Image Mobile"
            width="350px"
            height="200px" // Tamaño fijo para evitar CLS
            objectFit="contain"
            className="fade-in"
            loading="lazy"
          />
        )}
      </Flex>
      <Flex
        direction={{ base: "column", md: "row" }}
        p={8}
        justifyContent={"space-around"}
        alignItems={"center"}
        borderColor={useColorModeValue(colors.light.border, colors.dark.border)}
        borderWidth="1px"
        borderRadius={18}
        boxShadow="2xl"
        bg={useColorModeValue(
          colors.light.bgSecondary,
          colors.dark.bgSecondary,
        )}
        zIndex={1}
        position="relative"
        top="-20px"
      >
        <Flex
          width={{ base: "100%", md: "60%" }}
          justifyContent={"space-around"}
          gap={{ base: 6 }}
        >
          <Flex direction={"column"}>
            <Text fontSize={{ base: "1xl", md: "1xl" }}>Years</Text>
            <Text fontSize={{ base: "4xl", md: "6xl" }}>10+</Text>
          </Flex>
          <Flex direction={"column"}>
            <Text fontSize={{ base: "1xl", md: "1xl" }}>Lessons</Text>
            <Text fontSize={{ base: "4xl", md: "6xl" }}>
              {lessons.toLocaleString()}
            </Text>
          </Flex>
          <Flex direction={"column"}>
            <Text fontSize={{ base: "1xl", md: "1xl" }}>Materials</Text>
            <Text fontSize={{ base: "4xl", md: "6xl" }}>
              {materialesTotales.length}
            </Text>
          </Flex>
        </Flex>
        <Divider
          display={{ base: "block", md: "none" }}
          borderColor={useColorModeValue(
            colors.light.border,
            colors.dark.border,
          )}
          borderWidth="1px"
          height="auto"
          mt={2}
          mb={3}
        />
        <Flex
          direction={"column"}
          gap={{ base: 2, md: 5 }}
          alignSelf={{ md: "start" }}
          width={{ base: "100%", md: "auto" }}
          minW={0}
          textAlign={{ base: "center", md: "left" }}
        >
          <Text
            fontSize={{ base: "0.95rem", md: "1xl" }}
            whiteSpace="normal"
            wordBreak="break-word"
          >
            ⭐⭐⭐⭐⭐ 5/5
          </Text>
          <Text
            fontSize={{ base: "0.95rem", md: "1xl" }}
            maxW={{ base: "100%", md: "260px" }}
            whiteSpace="normal"
            wordBreak="break-word"
            lineHeight="1.4"
          >
            Students give Alex 5 Stars rating.
          </Text>
        </Flex>
      </Flex>
    </Layout>
  );
};

export default Header;
